export class NumberFormat {
  static SEPARATOR: string = '.';
  static SEPARATOR_PATTERN = new RegExp('\\' + NumberFormat.SEPARATOR, 'g');
  static ADD_SEPARATOR_PATTERN = /\B(?=(\d{3})+(?!\d))/g;
  static EMPTY_STRING = '';
  static DECIMAL_SEPARATOR = ',';

  private static replaceAll(text: string, searchRegex: RegExp, replace: string): string {
    const result = text.replace(searchRegex, replace);
    return result;
  }

  /**
   * Devuelve el string resultante de quitar los
   * separadores que se utilizan cada 3 dígitos.
   */
  static cleanNumberFormat(str: string): string {
    const cleaned = NumberFormat.replaceAll(str, this.SEPARATOR_PATTERN, this.EMPTY_STRING);
    return cleaned;
  }

  /**
   *  Recibe un string que representa a un número formateado (ejemplo 10.000)
   * y devuelve el correspondiente número. Si el string no representa un número,
   * devuelve undefined
   */
  static parseFormattedNumber(input: string | undefined): number | undefined {
    if (input == null) return undefined;
    const cleaned = NumberFormat.cleanNumberFormat(input.toString());
    const adapted = cleaned?.replace(this.DECIMAL_SEPARATOR, this.SEPARATOR);
    const adaptedNum: number = parseFloat(adapted);

    return isNaN(adaptedNum) ? undefined : adaptedNum;
  }

  /**
   * Formatea con separadores el número que recibe.
   * Devuelve el string resultante.
   */
  static formatNumber(input: string | number | undefined): string {
    if (input == null) return '';

    const inputStr = input.toString();
    const cleaned = NumberFormat.cleanNumberFormat(inputStr);
    const modified = cleaned.replace(NumberFormat.ADD_SEPARATOR_PATTERN, NumberFormat.SEPARATOR);

    return modified;
  }
}
